import { postJson } from 'utils/http';

export function getCmsApiSubscribeUrl(subsiteId: string) {
  return `/data/website/subsite-subscribe-email/${subsiteId}`;
}

export function subscribeToCmsApiSubsite(subsiteId: string): Promise<void> {
  return postJson(getCmsApiSubscribeUrl(subsiteId));
}
